import React from 'react';
import Button from './Button';

/**
 * APEX Design System — EmptyState
 *
 * Composant CLÉ pour les empty states "compagnon".
 *
 * Affiche un titre chaleureux avec emoji, un message, et une CTA claire.
 * Utilise les textes officiels de COPY (src/copy.js).
 *
 * Props:
 *   - title         : titre (déjà avec emoji intégré idéalement)
 *   - body          : corps du message
 *   - ctaLabel      : libellé du bouton principal
 *   - onCtaClick    : action du bouton principal
 *   - ctaVariant    : variant du bouton (default: primary)
 *   - secondaryLabel: libellé bouton secondaire (optionnel)
 *   - onSecondary   : action bouton secondaire
 *   - size          : sm | md | lg
 *
 * Usage:
 *   Les textes sont définis inline ou dans constants.js.
 *
 *   <EmptyState
 *     title={COPY.emptyDashboard.title}
 *     body={COPY.emptyDashboard.body}
 *     ctaLabel={COPY.emptyDashboard.cta}
 *     onCtaClick={() => setShowRiotImport(true)}
 *   />
 */

const SIZES = {
  sm: {
    container: 'p-6',
    title: 'text-base',
    body: 'text-xs max-w-md'
  },
  md: {
    container: 'p-8',
    title: 'text-lg',
    body: 'text-sm max-w-lg'
  },
  lg: {
    container: 'p-12',
    title: 'text-xl',
    body: 'text-base max-w-xl'
  }
};

export default function EmptyState({
  title,
  body,
  ctaLabel,
  onCtaClick,
  ctaVariant = 'primary',
  secondaryLabel,
  onSecondary,
  size = 'md',
  className = ''
}) {
  const sz = SIZES[size];
  return (
    <div className={`
      border border-zinc-800 bg-zinc-950
      ${sz.container}
      text-center
      flex flex-col items-center justify-center gap-4
      ${className}
    `}>
      {title && (
        <h3 className={`${sz.title} font-bold text-white`}>
          {title}
        </h3>
      )}
      {body && (
        <p className={`${sz.body} text-zinc-400 leading-relaxed mx-auto`}>
          {body}
        </p>
      )}
      {(ctaLabel || secondaryLabel) && (
        <div className="flex flex-wrap gap-2 justify-center mt-2">
          {ctaLabel && (
            <Button variant={ctaVariant} onClick={onCtaClick}>
              {ctaLabel.toUpperCase()}
            </Button>
          )}
          {secondaryLabel && (
            <Button variant="secondary" onClick={onSecondary}>
              {secondaryLabel.toUpperCase()}
            </Button>
          )}
        </div>
      )}
    </div>
  );
}
